import React from 'react';
import { Col, Row } from '@themesberg/react-bootstrap';
import Sidebar from './Sidebar'; // Assuming you have a Sidebar component
import Navbar from './Navbar';
// import Navbar from './Navbar';   // Assuming you have a Navbar component

const MainLayout = ({ children }) => {
  return (
    <div className="d-flex">
      {/* Sidebar */}
      <Sidebar />  
      
      {/* Main content area */}
      <div className="content flex-grow-1 p-3">
        {/* Optional: Add Navbar if needed */}
        {/* <Navbar /> */}
        <Navbar/>
        
        {/* The actual page content (like DashboardOverview) */}
        {children}
      </div>
    </div>
  );
};

export default MainLayout;
